/*
 * Copyright Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// noinspection ES6UnusedImports
import m from "mithril";
import {f} from "helpers/form_helper";

function withAttr(attrName, callback1, context) {
  return function(e) {
    callback1.call(context || this, attrName in e.currentTarget ? e.currentTarget[attrName] : e.currentTarget.getAttribute(attrName));
  };
}

export const PipelinePauseModalBody = {
  oncreate(vnode) {
    const input = vnode.dom.querySelector('input');
    if (input !== null) {
      //workaround to make input.focus work on chrome
      window.setTimeout(input.focus.bind(input), 10);
    }
  },

  view(vnode) {
    const pauseMessage  = vnode.attrs.message;

    return (<div>
      <f.input oninput={withAttr("value", pauseMessage)}
               value={pauseMessage()}
               label={[
                 <span
                   class="required">Specify a reason for pausing schedule on pipeline {vnode.attrs.pipelineName}</span>,
               ]}
      />
    </div>);
  }
};
